import React from 'react';
import MapIcon from '@material-ui/icons/Map';
import PhoneIcon from '@material-ui/icons/Phone';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import ReceiptIcon from '@material-ui/icons/Receipt';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import { MDBBtn } from 'mdb-react-ui-kit';

const IconMenu = ({ location_origin, iconMenu }) => {

  return (
    <div className={`container ${iconMenu}`}>
      <a
        className={iconMenu}
        href="https://goo.gl/maps/cjzqhqb31f4Spurg7"
        target="_blank"
        rel="noreferrer"
      >
        <MDBBtn toggle className="text-dark" color="light">
          <MapIcon fontSize="large" className="iconMargin" />
          Mappa
        </MDBBtn>
      </a>
      <a className={iconMenu} href="tel:+3904221628653">
        <MDBBtn toggle className="text-dark" color="light">
          <PhoneIcon fontSize="large" className="iconMargin" />
          Chiama
        </MDBBtn>
      </a>
      <a
        className={iconMenu}
        target="_blank"
        href="https://api.whatsapp.com/send/?phone=3904221628653"
        rel="noreferrer"
      >
        <MDBBtn toggle className="text-dark" color="light">
          <WhatsAppIcon fontSize="large" className="iconMargin" />
          WhatsApp
        </MDBBtn>
      </a>
      <a className={iconMenu} href={`${location_origin}preventivo`}>
        <MDBBtn toggle className="text-dark" color="warning">
          <ReceiptIcon fontSize="large" className="iconMargin" />
          Preventivo
        </MDBBtn>
      </a>
      {/* <a className={iconMenu} href={`${location_origin}area-riservata`}>
        <MDBBtn toggle className="text-dark" color="light">
          <VpnKeyIcon fontSize="large" className="iconMargin" />
          Area Riservata
        </MDBBtn>
      </a> */}
    </div>
  );
};

export default IconMenu;
